import styled, { css } from 'styled-components';
import { MTagProps, MTagType } from './MTag.types';
import { baseVariables } from '../../utils/TempMiUiLibraryUtils';

const { spacers, border, opacity, color } = baseVariables;

type StyleProps = Pick<MTagProps, 'type'>;

const stylesByType = ({ type }: StyleProps) => {
  switch (type) {
    case MTagType.Overlay:
      return css`
        background-color: rgba(0, 0, 0, ${opacity?.opacity5 ?? '0.54'});
        span {
          color: ${color?.base20 ?? '#ffffff'};
        }
      `;
    case MTagType.Accent:
      // background-color: var(--t-accent-color);
      return css`
        background-color: ${color?.accent10 ?? '#ff8d6b'};
        > span {
          color: ${color?.base10 ?? '#1c1c1c'};
        }
      `;
    case MTagType.Inverse:
      return css`
        background-color: ${color?.base10 ?? '#1c1c1c'};
        > span {
          color: ${color?.base20 ?? '#ffffff'};
        }
      `;
    case MTagType.Alternate:
      return css`
        background-color: ${color?.neutral10 ?? '#f4f4f4'};
        > span {
          color: ${color?.base10 ?? '#1c1c1c'};
        }
      `;
    case MTagType.Default:
    default:
      return css`
        background-color: ${color?.base20 ?? '#ffffff'};
        > span {
          color: ${color?.base10 ?? '#1c1c1c'};
        }
      `;
  }
};

export const Wrapper = styled.div<StyleProps>`
  display: inline-flex;
  height: 1.375rem;
  align-items: center;
  justify-content: center;
  gap: ${spacers?.spacers?.[1] ?? '0.25rem'};
  padding-inline: ${spacers?.spacers?.[2] ?? '0.5rem'};
  border-radius: ${border?.borderRadius02 ?? '0.25rem'};
  ${stylesByType}
`;
